import { useState } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  CardActions, 
  CardMedia,
  IconButton,
  Box
} from '@mui/material';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ProductCard({ product, onDelete, onEdit }) {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteConfirm = () => {
    onDelete(product.id);
    setDeleteModalOpen(false);
  };

  return (
    <>
      <Card sx={{ maxWidth: 120, p: 0 }}>
        <CardMedia
          component="img"
          image={product.image}
          alt={product.name}
          sx={{ 
            maxHeight:'90px',
            objectFit: 'contain',
            bgcolor: '#f5f5f5',
            aspectRatio: '4/3',
            background: `linear-gradient(45deg, #f0f0f0 25%, #ffffff 50%, #f0f0f0 75%)`,
            backgroundSize: '200% 200%',
            animation: 'shimmer 1.5s infinite',
          }}
        />
        <CardContent>
          <Typography gutterBottom variant="h6" component="div">
            {product.name}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" sx={{mr: 3}} color="text.secondary">{product.price} СУММ</Typography>
            <Typography variant="body2" color="text.secondary">{product.stock} дона</Typography>
          </Box>
        </CardContent>
        <CardActions>
          <IconButton size="small" onClick={() => onEdit(product)} edge="end" aria-label="edit" sx={{mr: 3}}>
              <EditIcon />
          </IconButton>
          <IconButton 
            size="small" 
            color="error" 
            onClick={() => setDeleteModalOpen(true)}
            edge="end"
            aria-label="delete"
          >
            <DeleteIcon />
          </IconButton>
        </CardActions>
      </Card>

      <ConfirmDeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
        itemName={product.name}
      />
    </>
  );
}	